/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
const styles = {
  container: {
    position: 'fixed',
    top: '65px',
    right: '0px',
    bottom: '0px',
    left: '0px',
    zIndex: 2000, // MUI Modal has 1300 zIndex
  },
  circularProgress: {
    position: 'fixed',
    top: 'calc(50% - 45px)',
    left: 'calc(50% - 45px)',
  },
};

function Loading(props) {
  const { classes, size } = props;
  return (
    <div className={classes.container}>
      <CircularProgress className={classes.circularProgress} size={size} thickness={1} color='primary' />
    </div>
  );
}

Loading.propTypes = {
  classes: PropTypes.object.isRequired,
  size: PropTypes.number,
};

Loading.defaultProps = {
  size: 90,
};

export default withStyles(styles)(Loading);
